// This is a generated file. Manual changes will be overwritten.

import React from "react";
import PropTypes from "prop-types";

export function IconCommunityBlue({ className, size, color }) {
  const s = size || "1em";

  const attr = { version: "1.1", viewBox: "0 0 32 32" };

  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      {...attr}
      className={className}
      style={{ color }}
      height={s}
      width={s}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.6 14.894c0-4.36 3.819-7.894 8.531-7.894 4.713 0 8.533 3.534 8.533 7.894 0 2.396-1.152 4.542-2.972 5.99 0.074 0.779 0.312 2.63 0.994 4.116-0.966-0.114-3.646-1.858-4.514-2.437-0.653 0.148-1.336 0.227-2.040 0.227-4.712-0-8.531-3.535-8.531-7.896z" />
    </svg>
  );
}

IconCommunityBlue.propTypes = {
  /**
   * Size in pixels (or a string with the size in CSS units)
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * A CSS color string.
   */
  color: PropTypes.string,
};
